import React from 'react';
import { AttachedService } from '@jbhi-fi/components/src/Cart/AttachedService/AttachedService';
import { formatMoney } from '@jbhi-fi/lanyard-ui/global/utils';
import { styles } from './CartService.css';
import { AttachedServiceEntry } from '../cartLineServices';
import { AttachedServiceProps } from '@jbhi-fi/components/src/Cart/AttachedService/AttachedService';

type AttachedServiceVariant = 'cart' | 'miniCart';

export interface AttachedServicesBlockProps {
  lineId: string;
  variant: AttachedServiceVariant;
  isNoLongerAvailable?: boolean;
  attachedInstallServices: Array<AttachedServiceEntry>;
  attachedService?: AttachedServiceProps;
  removeInstallServices?: () => void;
  removeAttachedService?: () => void;
}

const renderAttachedInstallService = (
  lineId: string,
  variant: AttachedServiceVariant,
  isNoLongerAvailable: boolean | undefined,
  attachedInstallServices: Array<AttachedServiceEntry>,
  removeInstallServices?: () => void
) => {
  if (!attachedInstallServices.length) return null;
  //TODO: for next iteration of service refactor.
  // current implementation is based on the assumption that item will longest general title will be the one we are required to display as group title.
  //We can get away with the whole enrichment of service data with generalTitle while adding item to the cart and here use the logic of working out the group title based on skus in checkout (NonFulfillableInstalls.tsx)
  const generalTitle =
    attachedInstallServices
      .map(s => (s?.serviceData?.generalTitle ?? '').trim())
      .filter(Boolean)
      .sort((a, b) => b.length - a.length)[0] ?? '';
  const totalPrice = attachedInstallServices.reduce((sum, entry) => sum + entry.cartItem.line_price / 100, 0);

  const subtextLines = attachedInstallServices.map(entry => {
    const label = entry.serviceData.offeringName ?? entry.cartItem.product_title ?? '';
    const priceValue = entry.cartItem.line_price / 100;
    return `• ${label} ${priceValue === 0 ? 'FREE' : priceValue ? formatMoney(priceValue) : ''}`;
  });

  const firstImage = attachedInstallServices.find(entry => entry.cartItem.image)?.cartItem.image;
  const isValid = attachedInstallServices.every(entry => entry.cartItem.isValidService !== false);

  return (
    <AttachedService
      key={`tvinstall-attached-${lineId}`}
      name={generalTitle}
      subtext={subtextLines.join('\n')}
      price={totalPrice}
      imageUrl={firstImage}
      isValid={isValid}
      hideActions={isNoLongerAvailable}
      onRemove={removeInstallServices}
      variant={variant}
    />
  );
};

const renderAttachedNonInstallService = (
  lineId: string,
  variant: AttachedServiceVariant,
  attachedService: AttachedServiceProps | undefined,
  removeAttachedService?: () => void
) => {
  if (!attachedService) return null;
  return <AttachedService key={lineId} {...attachedService} onRemove={removeAttachedService} variant={variant} />;
};

export const AttachedServicesBlock = ({
  lineId,
  variant,
  isNoLongerAvailable,
  attachedInstallServices,
  attachedService,
  removeInstallServices,
  removeAttachedService,
}: AttachedServicesBlockProps) => {
  const attachedInstallService = renderAttachedInstallService(
    lineId,
    variant,
    isNoLongerAvailable,
    attachedInstallServices,
    removeInstallServices
  );
  const attachedNonInstallService = renderAttachedNonInstallService(
    lineId,
    variant,
    attachedService,
    removeAttachedService
  );

  if (!attachedInstallService && !attachedNonInstallService) {
    return null;
  }

  return (
    <div className={styles.attachedServices}>
      {attachedInstallService}
      {attachedNonInstallService}
    </div>
  );
};
